/**
 * Display-only formatting. The backend transports money as decimal
 * **strings** (BigDecimal/HALF_EVEN — CLAUDE.md invariant #7); `Number(...)`
 * here is only ever used to compute a chart's pixel geometry or a rounded
 * display string — never fed back into a calculation, and never presented
 * as more precise than the source string.
 */

export function formatMoney(amount: string, currency: string): string {
  const value = Number(amount)
  if (!Number.isFinite(value)) return `${amount} ${currency}`
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 0 }).format(value)
  } catch {
    return `${value.toLocaleString()} ${currency}`
  }
}

export function formatCount(n: number): string {
  return n.toLocaleString()
}

export function formatPercent(pct: number): string {
  return `${pct >= 0 ? '+' : ''}${pct.toFixed(1)}%`
}

/**
 * IB-282 View 3, AC3.2 — a cartridge `Parameter` rate is authored as a fraction (e.g. `"0.20"` for
 * 20%, `docs/statutory-parameters-film.md`), never a whole percent. `Number.isNaN(rate)` is the
 * sentinel `analyticsMappers.ts` uses for "no uplift authored" (never a fabricated `0`) — rendered
 * as an explicit label, never a numeric `0%` a screen-reader/table user could misread as a real
 * zero-rate uplift.
 */
export function formatRatePercent(rate: number): string {
  return Number.isNaN(rate) ? 'No uplift' : `${(rate * 100).toFixed(1)}%`
}
